import React from 'react';

import { InformationMessageViolationDtoFormFieldEnum } from 'lib_api/lib/api/gen';

import { TextArea } from 'components/WrappedComponents';
import { FieldProps } from 'components/WrappedComponents/Form/FormWrapper/type';
import { useApi } from 'hooks/ApiStoreContext';
import { FormPlaceholders } from 'types/enums/FormPlaceholders';
import { InformationMessageFormValues } from 'types/InformationMessage/InformationMessage';
import { CSSUtils } from 'utils/CSSUtils';

import {
  generateRequestDtoFromFormData,
  validateInformationMessageRequest,
} from '../utils';

function InputContent({
  values,
}: FieldProps<InformationMessageFormValues>): React.ReactElement {
  const controller = useApi().AdminFonctionnelControllerApi;
  const key: keyof InformationMessageFormValues = 'content';

  return (
    <TextArea
      wrapperProps={{
        values: values,
        fieldKey: key,
        itemProps: {
          label: 'Contenu',
          rules: [
            {
              required: true,
              validator: async (
                _rule,
                value: string | undefined,
              ): Promise<void> => {
                const requestObject = generateRequestDtoFromFormData({
                  ...values,
                  content: value || undefined,
                });

                return await validateInformationMessageRequest(
                  controller,
                  requestObject,
                  InformationMessageViolationDtoFormFieldEnum.CONTENT,
                );
              },
            },
          ],
          labelCol: { span: CSSUtils.LlargeWrapperCol },
          wrapperCol: { span: CSSUtils.defaultLabelCol },
        },
      }}
      textAreaProps={{ placeholder: FormPlaceholders.Input }}
    />
  );
}

export default InputContent;
